Currency.format = 'money_format';

var shopCurrency = _theme.currency.shop_currency;

/* Sometimes merchants change their shop currency, let's tell our JavaScript file */
Currency.moneyFormats[shopCurrency].money_with_currency_format =
  _theme.currency.money_with_currency_format;
Currency.moneyFormats[shopCurrency].money_format = _theme.currency.money_format;

/* Default currency */
var defaultCurrency =
  "USD";

/* Cookie currency */
var cookieCurrency = Currency.cookie.read();

/* Fix for customer account pages */
jQuery("span.money span.money").each(function () {
  jQuery(this).parents("span.money").removeClass("money");
});

/* Saving the current price */
jQuery("span.money").each(function () {
  jQuery(this).attr("data-currency-", jQuery(this).html());
});

// If there's no cookie.
if (cookieCurrency == null) {
  if (shopCurrency !== defaultCurrency) {
    Currency.convertAll(shopCurrency, defaultCurrency);
  } else {
    Currency.currentCurrency = defaultCurrency;
  }
}
// If the cookie value does not correspond to any value in the currency dropdown.
else if (
  jQuery("[name=currencies]").length &&
  jQuery("[name=currencies] option[value=" + cookieCurrency + "]").length === 0
) {
  Currency.currentCurrency = shopCurrency;
  Currency.cookie.write(shopCurrency);
} else if (cookieCurrency === shopCurrency) {
  Currency.currentCurrency = shopCurrency;
} else {
  Currency.convertAll(shopCurrency, cookieCurrency);
}

jQuery("[name=currencies]")
  .val(Currency.currentCurrency)
  .change(function () {
    var newCurrency = jQuery(this).val();
    Currency.convertAll(Currency.currentCurrency, newCurrency);
    jQuery(".selected-currency").text(Currency.currentCurrency);
  });

var original_selectCallback = window.selectCallback;
var selectCallback = function (variant, selector) {
  original_selectCallback(variant, selector);
  Currency.convertAll(shopCurrency, jQuery("[name=currencies]").val());
  jQuery(".selected-currency").text(Currency.currentCurrency);
};

$("body").on("ajaxCart.afterCartLoad", function (cart) {
  Currency.convertAll(shopCurrency, jQuery("[name=currencies]").val());
  jQuery(".selected-currency").text(Currency.currentCurrency);
});

jQuery(".selected-currency").text(Currency.currentCurrency);
